import { useEffect } from "react";
import SEO from "./routes.json";

export const SITE = SEO.site;
export const ORG_ID = `${SITE}/#organization`;
export const SITE_ID = `${SITE}/#website`;
export const PERSON_ID = `${SITE}/founder/zahir-patel#person`;

const upsert = (selector, make, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = make();
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};
const meta = (key, value, prop = "name") =>
  upsert(`meta[${prop}="${key}"]`, () => { const m = document.createElement("meta"); m.setAttribute(prop, key); return m; }, "content", value);

export function useSeo(path, override) {
  const oTitle = override?.title;
  useEffect(() => {
    const base = SEO.routes.find((x) => x.path === path) || SEO.routes[0];
    const r = override ? { ...base, path, noindex: false, ...override } : base;
    const url = `${SITE}${r.path === "/" ? "/" : r.path}`;
    document.title = r.title;
    meta("description", r.description);
    meta("robots", r.noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
    upsert('link[rel="canonical"]', () => { const l = document.createElement("link"); l.rel = "canonical"; return l; }, "href", url);
    meta("og:title", r.title, "property");
    meta("og:description", r.description, "property");
    meta("og:url", url, "property");
    meta("og:type", r.ogType || (path.startsWith("/founder/") ? "profile" : "website"), "property");
    meta("og:image", r.image ? `${SITE}${r.image}` : SEO.image, "property");
    meta("twitter:image", r.image ? `${SITE}${r.image}` : SEO.image);
    meta("twitter:title", r.title);
    meta("twitter:description", r.description);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, oTitle]);
}

export const JsonLd = ({ data }) => (
  <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />
);
